import React, { useContext, useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import ContenidoPersonalSucursal from './ContenidoPersonalSucursal';
import Modal from 'react-bootstrap/Modal';
import xlsx from 'sheetjs-style';
import * as FileSaver from 'file-saver';
import { ContextGloball } from '../Context/ContextGlobal';
const server = process.env.REACT_APP_SERVER;
function ReportePersonalSucursal() {
    const {loading,setLoading} = useContext(ContextGloball);
    const [regional, setRegional] = useState('');
    const [listaPersonalSuc, setListaPersonalSuc] = useState([]);
    const [actualizar, setActualizar] = useState(false);
    const [modalResumen, setModalResumen] = useState(false);
    const [resumen, setResumen] = useState([]);
    function obtenerInfo(reg) {
        fetch(`${server}/reporte/getPersonalSucursal`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional: reg,
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    MsgUtils.msgError(data.error);
                } else {
                    setListaPersonalSuc(data.ok);
                }
                setLoading(false);
            })
            .catch(err => console.log(err));
    }
    function buscarSucursal() {
        var input, filter, cuadro, tr, td, i, txtValue;
        input = document.getElementById("buscarRespuestaE");
        filter = input.value.toUpperCase();
        cuadro = document.getElementById("listaSucursales");
        tr = cuadro.getElementsByClassName("buscareAqui");
        for (i = 0; i < tr.length; i++) {
            td = tr[i].getElementsByTagName("div")[0];
            if (td) {
                txtValue = td.innerHTML;
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                    tr[i].style.display = "";
                } else {
                    tr[i].style.display = "none";
                }
            }
        }
    }
    function getRequeridosAsignados(resultado, requeridos, asignados) {
        var aux = requeridos.filter((item) => item.ROL === 'PRD' && item.TURNO === 'M')[0];
        var req = aux !== undefined ? aux.CANTIDAD : 0;
        console.log(asignados.filter((item) => item.EMPRESA_TURNO === 'M' && [8, 9, 102].indexOf(item.EMPRESA_CARGO) >= 0));
        var asig = asignados.filter((item) => item.EMPRESA_TURNO === 'M' && [8, 9, 102].indexOf(item.EMPRESA_CARGO) >= 0).length;
        resultado.COCINA_DIA = asig - req;
        aux = requeridos.filter((item) => item.ROL === 'PRD' && item.TURNO === 'O')[0];
        req = aux !== undefined ? aux.CANTIDAD : 0;
        asig = asignados.filter((item) => item.EMPRESA_TURNO === 'O' && [8, 9, 102].indexOf(item.EMPRESA_CARGO) >= 0).length;
        resultado.COCINA_PARTIDO = asig - req;
        aux = requeridos.filter((item) => item.ROL === 'PRD' && item.TURNO === 'N')[0];
        req = aux !== undefined ? aux.CANTIDAD : 0;
        asig = asignados.filter((item) => item.EMPRESA_TURNO === 'N' && [8, 9, 102].indexOf(item.EMPRESA_CARGO) >= 0).length;
        resultado.COCINA_NOCHE = asig - req;
        aux = requeridos.filter((item) => item.ROL === 'CAJ' && item.TURNO === 'M')[0];
        req = aux !== undefined ? aux.CANTIDAD : 0;
        asig = asignados.filter((item) => item.EMPRESA_TURNO === 'M' && [10, 101, 100].indexOf(item.EMPRESA_CARGO) >= 0).length;
        resultado.CAJA_DIA = asig - req;
        aux = requeridos.filter((item) => item.ROL === 'CAJ' && item.TURNO === 'O')[0];
        req = aux !== undefined ? aux.CANTIDAD : 0;
        asig = asignados.filter((item) => item.EMPRESA_TURNO === 'O' && [10, 101, 100].indexOf(item.EMPRESA_CARGO) >= 0).length;
        resultado.CAJA_PARTIDO = asig - req;
        aux = requeridos.filter((item) => item.ROL === 'CAJ' && item.TURNO === 'N')[0];
        req = aux !== undefined ? aux.CANTIDAD : 0;
        asig = asignados.filter((item) => item.EMPRESA_TURNO === 'N' && [10, 101, 100].indexOf(item.EMPRESA_CARGO) >= 0).length;
        resultado.CAJA_NOCHE = asig - req;
        aux = requeridos.filter((item) => item.ROL === 'DSP' && item.TURNO === 'M')[0];
        req = aux !== undefined ? aux.CANTIDAD : 0;
        asig = asignados.filter((item) => item.EMPRESA_TURNO === 'M' && [11].indexOf(item.EMPRESA_CARGO) >= 0).length;
        resultado.DESPACHO_DIA = asig - req;
        aux = requeridos.filter((item) => item.ROL === 'DSP' && item.TURNO === 'O')[0];
        req = aux !== undefined ? aux.CANTIDAD : 0;
        asig = asignados.filter((item) => item.EMPRESA_TURNO === 'O' && [11].indexOf(item.EMPRESA_CARGO) >= 0).length;
        resultado.DESPACHO_PARTIDO = asig - req;
        aux = requeridos.filter((item) => item.ROL === 'DSP' && item.TURNO === 'N')[0];
        req = aux !== undefined ? aux.CANTIDAD : 0;
        asig = asignados.filter((item) => item.EMPRESA_TURNO === 'N' && [11].indexOf(item.EMPRESA_CARGO) >= 0).length;
        resultado.DESPACHO_NOCHE = asig - req;
        aux = requeridos.filter((item) => item.ROL === 'LIM' && item.TURNO === 'M')[0];
        req = aux !== undefined ? aux.CANTIDAD : 0;
        asig = asignados.filter((item) => item.EMPRESA_TURNO === 'M' && [12, 103].indexOf(item.EMPRESA_CARGO) >= 0).length;
        resultado.LIMPIEZA_DIA = asig - req;
        aux = requeridos.filter((item) => item.ROL === 'LIM' && item.TURNO === 'O')[0];
        req = aux !== undefined ? aux.CANTIDAD : 0;
        asig = asignados.filter((item) => item.EMPRESA_TURNO === 'O' && [12, 103].indexOf(item.EMPRESA_CARGO) >= 0).length;
        resultado.LIMPIEZA_PARTIDO = asig - req;
        aux = requeridos.filter((item) => item.ROL === 'LIM' && item.TURNO === 'N')[0];
        req = aux !== undefined ? aux.CANTIDAD : 0;
        asig = asignados.filter((item) => item.EMPRESA_TURNO === 'N' && [12, 103].indexOf(item.EMPRESA_CARGO) >= 0).length;
        resultado.LIMPIEZA_NOCHE = asig - req;
        aux = requeridos.filter((item) => item.ROL === 'GUA' && item.TURNO === 'M')[0];
        req = aux !== undefined ? aux.CANTIDAD : 0;
        asig = asignados.filter((item) => item.EMPRESA_TURNO === 'M' && [50, 104].indexOf(item.EMPRESA_CARGO) >= 0).length;
        resultado.SEGURIDAD_DIA = asig - req;
        aux = requeridos.filter((item) => item.ROL === 'GUA' && item.TURNO === 'O')[0];
        req = aux !== undefined ? aux.CANTIDAD : 0;
        asig = asignados.filter((item) => item.EMPRESA_TURNO === 'O' && [50, 104].indexOf(item.EMPRESA_CARGO) >= 0).length;
        resultado.SEGURIDAD_PARTIDO = asig - req;
        aux = requeridos.filter((item) => item.ROL === 'GUA' && item.TURNO === 'N')[0];
        req = aux !== undefined ? aux.CANTIDAD : 0;
        asig = asignados.filter((item) => item.EMPRESA_TURNO === 'N' && [50, 104].indexOf(item.EMPRESA_CARGO) >= 0).length;
        resultado.SEGURIDAD_NOCHE = asig - req;
        /*var aux=requeridos.filter((item)=>item.ROL==='PRD'&&item.TURNO==='M')[0];
        resultado.COCINA_REQU_DIA=aux!==undefined?aux.CANTIDAD:0;
        resultado.COCINA_ASIG_DIA=asignados.filter((item)=>item.EMPRESA_TURNO==='M'&&[8,9,102].indexOf(item.EMPRESA_CARGO)).length;
        resultado.DIF_COCINA_DIA = resultado.COCINA_ASIG_DIA-resultado.COCINA_REQU_DIA;
        aux=requeridos.filter((item)=>item.ROL==='PRD'&&item.TURNO==='O')[0];
        resultado.COCINA_REQU_PARTIDO=aux!==undefined?aux.CANTIDAD:0;
        resultado.COCINA_ASIG_PARTIDO=asignados.filter((item)=>item.EMPRESA_TURNO==='O'&&[8,9,102].indexOf(item.EMPRESA_CARGO)).length;
        resultado.DIF_COCINA_PARTIDO = resultado.COCINA_ASIG_PARTIDO-resultado.COCINA_REQU_PARTIDO;
        aux=requeridos.filter((item)=>item.ROL==='PRD'&&item.TURNO==='N')[0];
        resultado.COCINA_REQU_NOCHE=aux!==undefined?aux.CANTIDAD:0;
        resultado.COCINA_ASIG_NOCHE=asignados.filter((item)=>item.EMPRESA_TURNO==='N'&&[8,9,102].indexOf(item.EMPRESA_CARGO)).length;
        resultado.DIF_COCINA_NOCHE = resultado.COCINA_ASIG_DIA-resultado.COCINA_REQU_DIA;
        resultado.COCINA_SN_TURNO=asignados.filter((item)=>item.EMPRESA_TURNO==='X'&&[8,9,102].indexOf(item.EMPRESA_CARGO)).length;
        aux=requeridos.filter((item)=>item.ROL==='CAJ'&&item.TURNO==='M')[0];
        resultado.CAJA_REQU_DIA=aux!==undefined?aux.CANTIDAD:0;
        resultado.CAJA_ASIG_DIA=asignados.filter((item)=>item.EMPRESA_TURNO==='M'&&[10,101,100].indexOf(item.EMPRESA_CARGO)).length;
        resultado.DIF_CAJA_DIA = resultado.CAJA_ASIG_DIA-resultado.CAJA_REQU_DIA;
        aux=requeridos.filter((item)=>item.ROL==='CAJ'&&item.TURNO==='O')[0];
        resultado.CAJA_REQU_PARTIDO=aux!==undefined?aux.CANTIDAD:0;
        resultado.CAJA_ASIG_PARTIDO=asignados.filter((item)=>item.EMPRESA_TURNO==='O'&&[10,101,100].indexOf(item.EMPRESA_CARGO)).length;
        resultado.DIF_CAJA_PARTIDO = resultado.CAJA_ASIG_PARTIDO-resultado.CAJA_REQU_PARTIDO;
        aux=requeridos.filter((item)=>item.ROL==='CAJ'&&item.TURNO==='N')[0];
        resultado.CAJA_REQU_NOCHE=aux!==undefined?aux.CANTIDAD:0;
        resultado.CAJA_ASIG_NOCHE=asignados.filter((item)=>item.EMPRESA_TURNO==='N'&&[10,101,100].indexOf(item.EMPRESA_CARGO)).length;
        resultado.DIF_CAJA_NOCHE = resultado.CAJA_ASIG_NOCHE-resultado.CAJA_REQU_NOCHE;
        resultado.CAJA_SN_TURNO=asignados.filter((item)=>item.EMPRESA_TURNO==='X'&&[10,101,100].indexOf(item.EMPRESA_CARGO)).length;
        aux=requeridos.filter((item)=>item.ROL==='DSP'&&item.TURNO==='M')[0];
        resultado.DESPACHO_REQU_DIA=aux!==undefined?aux.CANTIDAD:0;
        resultado.DESPACHO_ASIG_DIA=asignados.filter((item)=>item.EMPRESA_TURNO==='M'&&[11].indexOf(item.EMPRESA_CARGO)).length;
        resultado.DIF_DESPACHO_DIA = resultado.DESPACHO_ASIG_DIA-resultado.DESPACHO_REQU_DIA;
        aux=requeridos.filter((item)=>item.ROL==='DSP'&&item.TURNO==='O')[0];
        resultado.DESPACHO_REQU_PARTIDO=aux!==undefined?aux.CANTIDAD:0;
        resultado.DESPACHO_ASIG_PARTIDO=asignados.filter((item)=>item.EMPRESA_TURNO==='O'&&[11].indexOf(item.EMPRESA_CARGO)).length;
        resultado.DIF_DESPACHO_PARTIDO = resultado.DESPACHO_ASIG_PARTIDO-resultado.DESPACHO_REQU_PARTIDO;
        aux=requeridos.filter((item)=>item.ROL==='DSP'&&item.TURNO==='N')[0];
        resultado.DESPACHO_REQU_NOCHE=aux!==undefined?aux.CANTIDAD:0;
        resultado.DESPACHO_ASIG_NOCHE=asignados.filter((item)=>item.EMPRESA_TURNO==='N'&&[11].indexOf(item.EMPRESA_CARGO)).length;
        resultado.DIF_DESPACHO_NOCHE = resultado.DESPACHO_ASIG_NOCHE-resultado.DESPACHO_REQU_NOCHE;
        resultado.DESPACHO_SN_TURNO=asignados.filter((item)=>item.EMPRESA_TURNO==='X'&&[11].indexOf(item.EMPRESA_CARGO)).length;
        aux=requeridos.filter((item)=>item.ROL==='LIM'&&item.TURNO==='M')[0];
        resultado.LIMPIEZA_REQU_DIA=aux!==undefined?aux.CANTIDAD:0;
        resultado.LIMPIEZA_ASIG_DIA=asignados.filter((item)=>item.EMPRESA_TURNO==='M'&&[12,103].indexOf(item.EMPRESA_CARGO)).length;
        resultado.DIF_LIMPIEZA_DIA = resultado.LIMPIEZA_ASIG_DIA-resultado.LIMPIEZA_REQU_DIA;
        aux=requeridos.filter((item)=>item.ROL==='LIM'&&item.TURNO==='O')[0];
        resultado.LIMPIEZA_REQU_PARTIDO=aux!==undefined?aux.CANTIDAD:0;
        resultado.LIMPIEZA_ASIG_PARTIDO=asignados.filter((item)=>item.EMPRESA_TURNO==='O'&&[12,103].indexOf(item.EMPRESA_CARGO)).length;
        resultado.DIF_LIMPIEZA_PARTIDO = resultado.LIMPIEZA_ASIG_PARTIDO-resultado.LIMPIEZA_REQU_PARTIDO;
        aux=requeridos.filter((item)=>item.ROL==='LIM'&&item.TURNO==='N')[0];
        resultado.LIMPIEZA_REQU_NOCHE=aux!==undefined?aux.CANTIDAD:0;
        resultado.LIMPIEZA_ASIG_NOCHE=asignados.filter((item)=>item.EMPRESA_TURNO==='N'&&[12,103].indexOf(item.EMPRESA_CARGO)).length;
        resultado.DIF_LIMPIEZA_NOCHE = resultado.LIMPIEZA_ASIG_NOCHE-resultado.LIMPIEZA_REQU_NOCHE;
        resultado.LIMPIEZA_SN_TURNO=asignados.filter((item)=>item.EMPRESA_TURNO==='X'&&[12,103].indexOf(item.EMPRESA_CARGO)).length;
        aux=requeridos.filter((item)=>item.ROL==='GUA'&&item.TURNO==='M')[0];
        resultado.SEGURIDAD_REQU_DIA=aux!==undefined?aux.CANTIDAD:0;
        resultado.SEGURIDAD_ASIG_DIA=asignados.filter((item)=>item.EMPRESA_TURNO==='M'&&[50,104].indexOf(item.EMPRESA_CARGO)).length;
        resultado.DIF_SEGURIDAD_DIA = resultado.SEGURIDAD_ASIG_DIA-resultado.SEGURIDAD_REQU_DIA;
        aux=requeridos.filter((item)=>item.ROL==='GUA'&&item.TURNO==='O')[0];
        resultado.SEGURIDAD_REQU_PARTIDO=aux!==undefined?aux.CANTIDAD:0;
        resultado.SEGURIDAD_ASIG_PARTIDO=asignados.filter((item)=>item.EMPRESA_TURNO==='O'&&[50,104].indexOf(item.EMPRESA_CARGO)).length;
        resultado.DIF_SEGURIDAD_PARTIDO = resultado.SEGURIDAD_ASIG_PARTIDO-resultado.SEGURIDAD_REQU_PARTIDO;
        aux=requeridos.filter((item)=>item.ROL==='GUA'&&item.TURNO==='N')[0];
        resultado.SEGURIDAD_REQU_NOCHE=aux!==undefined?aux.CANTIDAD:0;
        resultado.SEGURIDAD_ASIG_NOCHE=asignados.filter((item)=>item.EMPRESA_TURNO==='N'&&[50,104].indexOf(item.EMPRESA_CARGO)).length;
        resultado.DIF_SEGURIDAD_NOCHE = resultado.SEGURIDAD_ASIG_NOCHE-resultado.SEGURIDAD_REQU_NOCHE;
        resultado.SEGURIDAD_SN_TURNO=asignados.filter((item)=>item.EMPRESA_TURNO==='X'&&[50,104].indexOf(item.EMPRESA_CARGO)).length;*/
    }
    function generarExcel() {
        setLoading(true);
        var datosExcel = [];
        for (var res of listaPersonalSuc) {
            var obj = {
                "SUCURSAL": res.SUCURSAL,
            }
            getRequeridosAsignados(obj, res.REQUERIDO, res.ASIGNADO);
            datosExcel.push(obj)
        }
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        const fileExtencion = '.xlsx';
        const ws = xlsx.utils.json_to_sheet(datosExcel);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = xlsx.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, `ReportePersonalSucursal${regional == 990 ? 'CBBA' : 'SCRZ'}` + fileExtencion);
        setLoading(false);
    }
    function generarResumen() {
        var datosExcel = [];
        for (var res of listaPersonalSuc) {
            var obj = {
                "SUCURSAL": res.SUCURSAL,
            }
            getRequeridosAsignados(obj, res.REQUERIDO, res.ASIGNADO);
            datosExcel.push(obj)
        }
        setResumen(datosExcel);
        setModalResumen(true);
    }
    function definirColor(valor) {
        if (valor < 0) {
            return 'bg-danger text-light'
        } else if (valor > 0) {
            return 'text-light bg-success'
        }else{
            return 'bg-dark text-dark'
        }
    }
    useEffect(() => {
        setLoading(true);
        if (regional === '') {
            var info = JSON.parse(localStorage.getItem('info'));
            setRegional(info.ID_REGIONAL_ACTUAL);
            obtenerInfo('' + info.ID_REGIONAL_ACTUAL);
        } else {
            obtenerInfo('' + regional);
        }
    }, [actualizar])
    return (
        <div>
            <div className='container-fluid bg-dark bg-gradient py-1'>
                <div className='row row-cols g-1'>
                    <div className='col d-none'>
                        <div className="input-group input-group-sm my-auto" >
                            <span className="input-group-text bg-dark bg-gradient text-light border-dark" >Regional</span>
                            <select className=" form-select text-center" value={regional} onChange={(e) => setRegional(e.target.value)}>
                                <option value='990'>CBBA</option>
                                <option value='991'>SCRZ</option>
                            </select>
                        </div>
                    </div>
                    <div className='col' style={{maxWidth:'100px',minWidth:'100px'}}>
                        <button className='btn btn-sm btn-secondary w-100' onClick={() => setActualizar(!actualizar)}>
                            <i className="fa-solid fa-rotate-right fa-spin"></i> Cargar
                        </button>
                    </div>
                    <div className='col' style={{maxWidth:'160px',minWidth:'160px'}}>
                        <input className="form-control form-control-sm border-end-0 border rounded-pill"
                            placeholder='Buscar Sucursal'
                            type="text"
                            id="buscarRespuestaE"
                            onChange={() => buscarSucursal()} />
                    </div>
                    <div className='col' style={{maxWidth:'100px',minWidth:'100px'}}>
                        <button className='btn btn-sm btn-success w-100' onClick={() => generarResumen()}>
                            <i className="fa-solid fa-table"></i> Resum
                        </button>
                    </div>
                    <div className='col' style={{maxWidth:'100px',minWidth:'100px'}}>
                        <button className='btn btn-sm btn-success w-100' onClick={() => generarExcel()}>
                            <i className="fa-solid fa-file-excel"></i> Excel
                        </button>
                    </div>
                </div>
            </div>
            {loading == false && <div className='container-fluid py-2'>
                <div className='row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-3 g-2' id="listaSucursales">
                    {listaPersonalSuc.map((item, index) => {
                        return (
                            <div className='col col-12 col-sm-6 col-md-6 col-lg-4' key={index}>
                                <div className="card bg-dark bg-gradient buscareAqui" >
                                    <div className='card-header text-light fw-bold m-0 p-0 text-center '>
                                        {`Personal Sucursal ${item.SUCURSAL}`}
                                    </div>
                                    <ContenidoPersonalSucursal info={item} />
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>}
            <Modal show={modalResumen} onHide={() => setModalResumen(false)}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                contentClassName='bg-dark bg-gradient'>
                <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
                    <Modal.Title>
                        <div className='text-light'>Resumen</div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body bsPrefix='modal-body m-0 p-0'>
                    <div className='table-responsive'>
                        <table className="table table-sm table-bordered">
                            <thead>
                                <tr className='text-light fw-bold text-center'>
                                    <th colSpan="1"></th>
                                    <th colSpan="3">COCINA</th>
                                    <th colSpan="3">CAJA</th>
                                    <th colSpan="3">MESON</th>
                                    <th colSpan="3">LIMPIEZA</th>
                                    <th colSpan="3">SEGURIDAD</th>
                                </tr>
                                <tr className='text-light text-center'>
                                    <th colSpan="1">SUCURSAL</th>
                                    <th colSpan="1">MAÑ</th>
                                    <th colSpan="1">PAR</th>
                                    <th colSpan="1">NOCH</th>
                                    <th colSpan="1">MAÑ</th>
                                    <th colSpan="1">PAR</th>
                                    <th colSpan="1">NOCH</th>
                                    <th colSpan="1">MAÑ</th>
                                    <th colSpan="1">PAR</th>
                                    <th colSpan="1">NOCH</th>
                                    <th colSpan="1">MAÑ</th>
                                    <th colSpan="1">PAR</th>
                                    <th colSpan="1">NOCH</th>
                                    <th colSpan="1">MAÑ</th>
                                    <th colSpan="1">PAR</th>
                                    <th colSpan="1">NOCH</th>
                                </tr>
                            </thead>
                            <tbody>
                                {resumen.map((item,index) => {
                                    return (
                                        <tr className='text-center text-light' key={index}>
                                            <th colSpan="1">{item.SUCURSAL}</th>
                                            <th colSpan="1" className={definirColor(item.COCINA_DIA)}>{item.COCINA_DIA}</th>
                                            <th colSpan="1" className={definirColor(item.COCINA_PARTIDO)}>{item.COCINA_PARTIDO}</th>
                                            <th colSpan="1" className={definirColor(item.COCINA_NOCHE)}>{item.COCINA_NOCHE}</th>
                                            <th colSpan="1" className={definirColor(item.CAJA_DIA)}>{item.CAJA_DIA}</th>
                                            <th colSpan="1" className={definirColor(item.CAJA_PARTIDO)}>{item.CAJA_PARTIDO}</th>
                                            <th colSpan="1" className={definirColor(item.CAJA_NOCHE)}>{item.CAJA_NOCHE}</th>
                                            <th colSpan="1" className={definirColor(item.DESPACHO_DIA)}>{item.DESPACHO_DIA}</th>
                                            <th colSpan="1" className={definirColor(item.DESPACHO_PARTIDO)}>{item.DESPACHO_PARTIDO}</th>
                                            <th colSpan="1" className={definirColor(item.DESPACHO_NOCHE)}>{item.DESPACHO_NOCHE}</th>
                                            <th colSpan="1" className={definirColor(item.LIMPIEZA_DIA)}>{item.LIMPIEZA_DIA}</th>
                                            <th colSpan="1" className={definirColor(item.LIMPIEZA_PARTIDO)}>{item.LIMPIEZA_PARTIDO}</th>
                                            <th colSpan="1" className={definirColor(item.LIMPIEZA_NOCHE)}>{item.LIMPIEZA_NOCHE}</th>
                                            <th colSpan="1" className={definirColor(item.SEGURIDAD_DIA)}>{item.SEGURIDAD_DIA}</th>
                                            <th colSpan="1" className={definirColor(item.SEGURIDAD_PARTIDO)}>{item.SEGURIDAD_PARTIDO}</th>
                                            <th colSpan="1" className={definirColor(item.SEGURIDAD_NOCHE)}>{item.SEGURIDAD_NOCHE}</th>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default ReportePersonalSucursal
